export enum RentalItemType {
  PARKING_PLACE = 'ParkingPlace',
  POSTAL_BOX = 'PostalBox',
  CLEANING = 'Cleaning',
  ELECTRICITY_FEE = 'ElecticityFee',
  OTHER = 'Other',
}

export interface RentalItem {
  discountPercent: number;
  price: number;
  rentalItemType: RentalItemType;
  quantity: number;
  vatRatePercent: number;
  totalPrice: number;
  description?: Nullable<string>;
}
